import { useState } from "react";
import {
  Card,
  Form,
  Input,
  Button,
  message,
  Typography,
  Row,
  Col,
  InputNumber,
} from "antd";
import { BookOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import api from "../api/api";

const { Title, Text } = Typography;

export default function CrearEbook() {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  /* ===================== SUBMIT ===================== */
  const onFinish = async (values) => {
    setLoading(true);
    try {
      const payload = {
        normaEbook: values.normaEbook,
        idNormaProveedor: Number(values.idNormaProveedor),
      };

      await api.post("/api/AddEbook", payload);

      message.success("eBook creado correctamente");
      form.resetFields();
    } catch (error) {
      message.error("Error al crear eBook");
    } finally {
      setLoading(false);
    }
  };

  /* ===================== UI ===================== */
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        background: "linear-gradient(135deg,#e6f7ff,#f9f9f9)",
      }}
    >
      <Card
        style={{
          width: "100%",
          maxWidth: 600,
          borderRadius: 24,
          boxShadow: "0 20px 50px rgba(0,0,0,0.12)",
        }}
        bodyStyle={{ padding: 32 }}
      >
        {/* HEADER */}
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <Title level={3}>Crear eBook</Title>
          <Text type="secondary">Registro de nuevas normas digitales</Text>
        </div>

        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Row gutter={24}>
            <Col xs={24}>
              <Form.Item
                name="normaEbook"
                label="Nombre del eBook"
                rules={[{ required: true, message: "Ingrese el nombre" }]}
              >
                <Input
                  size="large"
                  prefix={<BookOutlined />}
                  placeholder="Ej: Norma ISO 9001"
                />
              </Form.Item>
            </Col>

            <Col xs={24}>
              <Form.Item
                name="idNormaProveedor"
                label="ID Norma Proveedor"
                rules={[{ required: true, message: "Ingrese el ID" }]}
              >
                <InputNumber
                  size="large"
                  style={{ width: "100%" }}
                  min={1}
                  placeholder="Ej: 123"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                block
                loading={loading}
                style={{
                  height: 50,
                  borderRadius: 14,
                  fontSize: 16,
                  background: "linear-gradient(90deg,#1890ff,#40a9ff)",
                }}
              >
                Crear eBook
              </Button>
            </Col>

            <Col xs={24} md={12}>
              <Button
                icon={<ArrowLeftOutlined />}
                size="large"
                block
                style={{ height: 50, borderRadius: 14 }}
                onClick={() => navigate("/dashboard/ebooks")}
              >
                Volver
              </Button>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  );
}
